/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export function normalizeMakeName(make: string) {
  return make?.toLowerCase().replace(/[./]/g, '').replace(/\s+/g, '-');
}
